import { NIVEL_SUPERIOR, NIVEL_TECNICO } from 'types/NivelCbo'

export const grupoCboAlergias = {
  visualizar: [...NIVEL_TECNICO, ...NIVEL_SUPERIOR],
  adicionarEditarExcluir: [...NIVEL_SUPERIOR],
}
